import { computed, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { $api } from './useApi';
import type { ServiceMenuItem } from '@/models/service';
import type { Social } from '@/models/social';
import type { LegalDocumentAlias } from '@/models/document';
import { useLegalDocumentStore } from '@/stores/legal-document-store';

export const useSharedContent = async () => {
  const { locale } = useI18n();

  const { setLegalDocumentAliases } = useLegalDocumentStore();

  const { data, refresh } = await useAsyncData(`shared-content`, async (_nuxtApp, options) => {
    const [menuData, socialData, legalDocumentAliasData] = await Promise.all([
      $api<ServiceMenuItem[]>('/menu-items', { signal: options?.signal }),
      $api<Social[]>('/socials', { signal: options?.signal }),
      $api<LegalDocumentAlias[]>('/legal-document', { signal: options?.signal })
    ]);

    return { menuData, socialData, legalDocumentAliasData };
  });

  const serviceMenuItems = computed(() => data.value?.menuData ?? []);

  const socials = computed(() => data.value?.socialData ?? []);

  watchEffect(() => {
    setLegalDocumentAliases(data.value.legalDocumentAliasData ?? []);
  });

  watch(locale, () => {
    refresh();
  });

  return {
    serviceMenuItems,
    socials
  };
};
